module.exports = __webpack_public_path__ + "img/higher-interstate-speed.ec25c1bc.jpg";